package gr.tech.GRAttestation.models.attestation

import kotlinx.serialization.Serializable

@Serializable
data class AttestationForm(
    val reportingMonth: String,
    val salesDataList: List<SalesData>,
    val repSignature: String,
    val repSignDate: String,
    val acceptedTerms: Boolean,

    // Needed for other section
    val incentiveAmount: Long,
    val quantity: Int,
)
